import React from "react";
import {
  FacebookIcon,
  FacebookShareButton,
  XIcon,
  TwitterShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  RedditIcon,
  RedditShareButton,
  TumblrIcon,
  TumblrShareButton,
  PinterestIcon,
  PinterestShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  EmailIcon,
  EmailShareButton,
} from "react-share";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import "./ShareButtons.css";

const ShareButtons = ({ url }) => {
  return (
    <div className="share-buttons-container">
      <FacebookShareButton url={url}>
        <FacebookIcon className="button" size={32} round />
      </FacebookShareButton>

      <TwitterShareButton url={url}>
        <XIcon className="button" size={32} round />
      </TwitterShareButton>

      <LinkedinShareButton url={url}>
        <LinkedinIcon className="button" size={32} round />
      </LinkedinShareButton>

      <RedditShareButton url={url}>
        <RedditIcon className="button" size={32} round />
      </RedditShareButton>

      <TumblrShareButton url={url}>
        <TumblrIcon className="button" size={32} round />
      </TumblrShareButton>

      <PinterestShareButton url={url}>
        <PinterestIcon className="button" size={32} round />
      </PinterestShareButton>

      <WhatsappShareButton url={url}>
        <WhatsappIcon className="button" size={32} round />
      </WhatsappShareButton>

      <EmailShareButton url={url}>
        <EmailIcon className="button" size={32} round />
      </EmailShareButton>
      <ContentCopyIcon
        onClick={() => {
          navigator.clipboard.writeText(url);
        }}
        className="button"
        fontSize="large"
      />
    </div>
  );
};

export default ShareButtons;
